import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { ClaimedBarComponent } from './claimed-bar/claimed-bar.component';
import { HeaderComponent } from './header/header.component';
import { PyErrorsComponent } from './py-errors/py-errors.component';
import { VideoPlayerComponent } from './video-player/video-player.component';
import { ShowNotificationComponent } from './show-notification/show-notification.component';
import { JuniorAidComponent } from './junior-aid/junior-aid.component';
import { PreviewInvoiceImageComponent } from './preview-invoice-image/preview-invoice-image.component';
import {PipesModule} from '../pipes/pipes.module';

@NgModule({
  imports: [
    CommonModule,
    IonicModule.forRoot(),
    ReactiveFormsModule, FormsModule,
    PipesModule
  ],
  declarations: [
    ClaimedBarComponent,
    HeaderComponent,
    PyErrorsComponent,
    VideoPlayerComponent,
    ShowNotificationComponent,
    JuniorAidComponent,
    PreviewInvoiceImageComponent
  ],
  exports: [
    ClaimedBarComponent,
    HeaderComponent,
    PyErrorsComponent,
    VideoPlayerComponent,
    ShowNotificationComponent,
    JuniorAidComponent,
    PreviewInvoiceImageComponent
  ]
})
export class ComponentsModule {
}
